export const findTopLevelParentKey = (tools, activeTool) => {
    for (let i = 0; i < tools.length; i++) {
        const tool = tools[i];
        if (tool.items) {
            const foundTool = tool.items?.some(item => typeof item === 'object' && item?.items?.includes(activeTool));
            if (foundTool) {
                return i;
            } else {
                const foundParentToolIndex = findTopLevelParentKey(tool.items, activeTool);
                if (foundParentToolIndex !== null) {
                    return i;
                }
            }
        }
        if (tool === activeTool) {
            return i;
        }
    }
    return null;
};

// Potřebujeme nalézt do jaké skupiny patří nástroj
export const findParentToolKey = (tools, activeTool) => {
    for (let i = 0; i < tools.length; i++) {
        const tool = tools[i];
        if (tool.items) {
            const foundTool = tool.items?.some(item => typeof item === 'object' && item?.items?.includes(activeTool));
            if (foundTool) {
                return i;
            } else {
                const foundParentToolIndex = findParentToolKey(tool.items, activeTool);
                if (foundParentToolIndex !== null) {
                    return foundParentToolIndex;
                }
            }
        }
    }
    return null;
};

export const findToolKeyById = (tools, toolId) => {
    for (let i = 0; i < tools.length; i++) {
        const tool = tools[i];
        if (tool.id === toolId) {
            return i;
        } else if (tool.items) {
            const foundToolKey = findToolKeyById(tool.items, toolId);
            if (foundToolKey !== null) {
                return foundToolKey;
            }
        }
    }
    return null;
};
